import React, { useState ,useEffect} from 'react';
import useUser from 'hooks/useUser';
import Cheat_Modal from 'components/cheats/cheat_modal/cheat_modal';
import "./admin-btn.css";

//Firebase
import "firebase/auth";

const Admin_btn = () => {
  const {register,error,success,profile,loadingUser,login_google,logout} = useUser()
  const [openModal,setOpenModal] = useState(false)
  let openCheatModal = () =>{
    setOpenModal(true)
  }
  return (
    <>
    {
      !loadingUser ? profile? profile.admin?
      <div className="adminActions">
        <input type="checkbox" name="adminToggle" className="adminToggle" />
        <a className="adminButton" href="#!"><i className="fa fa-cog"></i></a>
        <div className="adminButtons">
          <a title="Add Cheat" onClick={openCheatModal}><i className="fa fa-plus-square"></i></a>
          {/* <a href="#" title="Edit Company"><i className="fa fa-pen"></i></a>
          <a href="#" title="Add User"><i className="fa fa-user-plus"></i></a>
          <a href="#" title="Edit User"><i className="fa fa-user-edit"></i></a> */}
        </div>
      </div>
      :null:null:null
    }
    <Cheat_Modal open={openModal} setOpen={setOpenModal} type="create"/>
    </>

  );
};

export default Admin_btn;
